import { defaultMemoize } from 'reselect';

const LEGACY_ROOT_URL = '';

export const normalizeNavLink = defaultMemoize((link = '#') => {
  if (link.indexOf('https://appreciatehub.com') === 0) {
    return link.replace('https://appreciatehub.com', 'https://www.appreciatehub.com');
  }
  return link;
});

export const getAlertsId = defaultMemoize((link = '') => {
  const matches = /\/api\/alerts\/([0-9]+)/g.exec(link);
  return matches ? matches[1] : '';
});
  
export const getRecipientId = defaultMemoize((link = '') => {
  const matches = /printEProduct\.seam\?recipientId=([0-9]+)/g.exec(link);
  return matches ? matches[1] : '';
});
  
export const getReceiveLink = defaultMemoize((title = '', recipientId, alertId, legacyRootUrl = '') => {
  if (title.toLowerCase() === 'view' && recipientId) {
    return `${legacyRootUrl}/receiveECard.seam?eId=${recipientId}&alertId=${alertId}`;
  }
  return '/ui/greatwork/history.html';
});

export const flatten = defaultMemoize((arr) =>
  arr.reduce((acc, val) => acc.concat(Array.isArray(val) ? flatten(val) : val), []));

export const selectRedeemLink = defaultMemoize((receiveCollectionItem) => {
  const filteredList = receiveCollectionItem.links.filter(
    (link) => link.link.indexOf('catalog.jsf') > -1
  );
  if (filteredList.length > 0) return filteredList.slice(-1)[0].link;
  return '';
});
  
export const selectRedeemTitle = defaultMemoize((receiveCollectionItem) => {
  const filteredList = receiveCollectionItem.links.filter(
    (link) => link.link.indexOf('catalog.jsf') > -1
  );
  if (filteredList.length > 0) return filteredList.slice(-1)[0].title;
  return '';
});

export const selectReceiveLink = defaultMemoize(({ links = [], href = '' } = {}, legacyRootUrl = '') => {
  let receiveCollectionItemActions = links.filter(
    (link) => link.actions && link.actions.length > 0
  );
  receiveCollectionItemActions = receiveCollectionItemActions.length > 0
    ? receiveCollectionItemActions.map((link) =>
      link.actions.filter((action) => action.link.indexOf('printEProduct.seam') > -1)
    )
    : [];
  
  receiveCollectionItemActions = flatten(receiveCollectionItemActions);
  
  const recipientId = receiveCollectionItemActions.length > 0
    ? getRecipientId(receiveCollectionItemActions.slice(-1)[0].link)
    : 0;
  
  const hasViewLink =
      links.filter((link) => !!link.title && link.title.toLowerCase() === 'view')
        .length > 0;
  
  return getReceiveLink(
    hasViewLink ? 'view' : '',
    recipientId,
    getAlertsId(href),
    legacyRootUrl
  );
});

const buildGenericAlertArray = (...Arguments) =>
  Arguments.filter((cur) => !!cur).reduce((acc, cur) => {
    // This is to fix an inconsistant layout of alerts that are within
    // perfork, its a hack, yes, but its an easy one.
    if (Array.isArray(cur)) {
      // eslint-disable-next-line no-param-reassign
      cur = cur[0];
    }
    return acc.concat({
      title: cur.title,
      href: normalizeNavLink(cur.href)
    });
  }, []);

export const selectCompiledAlertsCount = defaultMemoize((
  {
    pendingApprovals = {
      count: 0
    },
    pendingPresentations = {
      count: 0
    },
    additionalInformation = {
      count: 0
    },
    passwordExpired = {
      count: 0
    },
    newReports = {
      count: 0
    },
    scheduledReports = {
      count: 0
    },
    proxyAssignment = {
      count: 0
    },
    pointsExpiring = {
      count: 0
    },
    accessCodeExpiring = {
      count: 0
    },
    receive = {
      count: 0
    }
  } = {}
) =>
  pendingApprovals.count +
    pendingPresentations.count +
    additionalInformation.count +
    passwordExpired.count +
    newReports.count +
    scheduledReports.count +
    proxyAssignment.count +
    pointsExpiring.count +
    accessCodeExpiring.count +
    receive.count);

export const selectCompiledGenericAlertsArray = defaultMemoize((
  {
    pendingApprovals = {
      link: ''
    },
    pendingPresentations = {
      link: ''
    },
    additionalInformation = {
      link: ''
    },
    passwordExpired = {
      link: ''
    },
    newReports = {
      collection: []
    },
    scheduledReports = {
      collection: []
    },
    proxyAssignment = {
      collection: []
    },
    pointsExpiring = {
      collection: []
    },
    accessCodeExpiring = {
      collection: []
    }
  } = {}
) =>
  [].concat(
    buildGenericAlertArray(
      pendingApprovals.link,
      pendingPresentations.link,
      additionalInformation.link,
      passwordExpired.link,
      ...newReports.collection,
      ...scheduledReports.collection,
      ...proxyAssignment.collection,
      ...pointsExpiring.collection,
      ...accessCodeExpiring.collection
    )
  ));

export const selectCompiledReceiveAlertsArray = defaultMemoize((
  {
    receive = {
      collection: []
    }
  } = {}
) =>
  [].concat(
    receive.collection.map((receiveItem) => ({
      href: selectReceiveLink(receiveItem, LEGACY_ROOT_URL),
      title: receiveItem.title,
      redeem: {
        href: selectRedeemLink(receiveItem),
        title: selectRedeemTitle(receiveItem)
      }
    }))
  ));